module.exports = __webpack_public_path__ + "static/media/flatBedTruck_indigo.71bf32c9.svg";